
export class Actualite {
  slug: string;
  title = '';
  text = '';
  thumb: string;
  date: string;
  is_home: boolean;
  is_home_date: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/actualite.model.ts